import firebase from 'firebase';

var config = {
    apiKey: "AIzaSyAPtb5mJ2ZI58tZa0siFc7h823CM3k1IJo",
    authDomain: "futuristiclabs-landing.firebaseapp.com",
    databaseURL: "https://futuristiclabs-landing.firebaseio.com",
    projectId: "futuristiclabs-landing",
    storageBucket: "futuristiclabs-landing.appspot.com",
    messagingSenderId: "51614671100",
    appId: "1:51614671100:web:9f0608dfce643e9a44f779"
  };
  firebase.initializeApp(config);

export const firestore = firebase.firestore()
export const ref = firebase.database().ref();
export const auth = firebase.auth;